"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SavingTask = void 0;
var _Modal = require("../../../Layout/Modal");
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
var _Button = require("../../../UI/Button");
var _Tooltip = require("../../../UI/Tooltip");
var _A = require("../../../UI/A");
var _Icon = require("../../../UI/Icon");
var _SectionCard = require("./partials/SectionCard");
var _dates = require("../../../utilities/dates");
var _cetEnvironment = require("../../../utilities/cetEnvironment");
var _TaskManager2 = _interopRequireDefault(require("../TaskManager.styles"));
var _AudiencePickerProvider = require("../../AudiencePicker/provider/AudiencePickerProvider.helpers");
var _hooks = require("../../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SavingTask = props => {
  const {
    isAssignedTaskUrlEnabled,
    handleClose,
    audiencePickerProvider
  } = props;
  const {
    getLabel,
    task,
    setIsShareItem,
    setIsSavedItem,
    setIsUpdate,
    setIsChanged,
    unitData
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const styles = (0, _TaskManager2.default)();
  const isTimeEnabled = task?.taskType === 'exam';
  const taskUrl = getLabel('lms_url').replace('{EnvDomain}', (0, _cetEnvironment.getCetEnvironmentInfo)().cetDomain);
  const handleShareBtnClick = () => {
    setIsShareItem(true);
  };
  const handleBackToEditClick = () => {
    setIsSavedItem(false);
    setIsUpdate(true);
    setIsChanged(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__full-item'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      messageIcon: "Checkmark",
      messageType: "success",
      message: getLabel('success_title'),
      subTitle: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-TaskManager__saving-task__title'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: task?.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "ccTaskManagerSaveTaskShareButton",
            view: "alternate",
            shape: "round",
            size: "large",
            onClick: handleShareBtnClick,
            category: "assignActivity",
            label: "shareActivity",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              name: "Share",
              width: "24",
              height: "24"
            })
          }),
          children: isMobileView ? '' : getLabel('share_Tooltip')
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Content, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionCard.SectionCard, {
        iconName: "Notebook",
        title: getLabel('text_label_activityType'),
        children: task?.taskType && unitData?.taskTypes && unitData.taskTypes[task.taskType]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionCard.SectionCard, {
        iconName: "Calendar",
        title: getLabel('text_label_when'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-TaskManager__saving-task__schedule'],
          children: [isTimeEnabled && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: task?.startDateTime && (0, _dates.formatDate)(task.startDateTime, '{hour}:{minute}')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "cc-taskManager-section-success-data-row-subTitle",
              children: getLabel('text_label_startTime')
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: task?.startDateTime && (0, _dates.formatDate)(task.startDateTime, '{day}.{month}.{year}')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "cc-taskManager-section-success-data-row-subTitle",
              children: getLabel('text_label_startDate')
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-TaskManager__saving-task__schedule__spacer']
          }), isTimeEnabled && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: task?.endDateTime && (0, _dates.formatDate)(task.endDateTime, '{hour}:{minute}')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "cc-taskManager-section-success-data-row-subTitle",
              children: getLabel('text_label_submissionTime')
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: task?.endDateTime && (0, _dates.formatDate)(task.endDateTime, '{day}.{month}.{year}')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "cc-taskManager-section-success-data-row-subTitle",
              children: getLabel('text_label_submissionDate')
            })]
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionCard.SectionCard, {
        iconName: "Contact",
        title: `${getLabel('text_label_isAssociateTo')} ${task?.assignTo === 'some' ? `${task?.singleUsersCount} ${getLabel('students')}` : ''}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-TaskManager__saving-task__groups-and-students'],
          children: task?.assignTo === 'all' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: getLabel('all_students')
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              children: [audiencePickerProvider && audiencePickerProvider.selectedClassesIds && audiencePickerProvider.classesMapper && audiencePickerProvider.selectedClassesIds.map(id => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: audiencePickerProvider.classesMapper && audiencePickerProvider.classesMapper[id]?.group?.name
              }, id)), audiencePickerProvider && audiencePickerProvider.selectedGroupsIds && audiencePickerProvider.groupsMapper && audiencePickerProvider.selectedGroupsIds.map(id => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: audiencePickerProvider.groupsMapper && audiencePickerProvider.groupsMapper[id]?.group?.name
              }, id))]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: audiencePickerProvider && audiencePickerProvider.selectedStudentsIds && audiencePickerProvider.studentsMapper && audiencePickerProvider.selectedStudentsIds.map(id => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: audiencePickerProvider.studentsMapper && (0, _AudiencePickerProvider.getStudentFullName)(audiencePickerProvider.studentsMapper[id]?.student)
              }, id))
            })]
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-TaskManager__saving-task__footer'],
        children: [isAssignedTaskUrlEnabled && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "cc-taskManager-section-success-link",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "cc-taskManager-section-success-link_label",
            children: getLabel('success_goto_lms_label')
          }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
            id: "ccTaskManagerSaveTaskSuccessGoToLMSAnchor",
            to: taskUrl,
            target: "_top",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: getLabel('success_goto_lms_btn')
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "cc-taskManager-section-success-link",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "ccTaskManagerSaveTaskBackToEditButton",
            view: "link",
            onClick: handleBackToEditClick,
            children: getLabel('success_back_to_edit_btn')
          })
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer, {
      justifyContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: "ccTaskManagerSaveTaskCloseButton",
          view: "outlined",
          onClick: handleClose,
          children: getLabel('close')
        })
      })
    })]
  });
};
exports.SavingTask = SavingTask;